export const GET_TRIPSETA_REQUEST = 'GET_TRIPSETA_REQUEST'
export const GET_TRIPSETA_SUCCESS = 'GET_TRIPSETA_SUCCESS'
export const GET_TRIPSETA_FAILURE = 'GET_TRIPSETA_FAILURE'